<app-feedback [(settings)]="feedbackSettings"> </app-feedback>
